import { render } from "./MovementInstructionLotProductSpecs.vue?vue&type=template&id=efabf820&scoped=true"
import script from "./MovementInstructionLotProductSpecs.vue?vue&type=script&lang=js"
export * from "./MovementInstructionLotProductSpecs.vue?vue&type=script&lang=js"

import "./MovementInstructionLotProductSpecs.vue?vue&type=style&index=0&id=efabf820&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efabf820"]])

export default __exports__